const EMPTY_DIAGNOSTICS_ITEM = Object.freeze({
  phoneNumber: null,
  duplicateCount: null,
  smsId: null,
  customerName: null,
  customerId: null,
  createdTime: null,
  customerStatus: null,
  classType: null,
  productFamily: null,
  timeZoneId: null,
  accountType: null,
  firstName: null,
  lastName: null,
  primaryEmail: null,
  primaryExtension: null,
  userStatus: null,
  loginId: null,
  userId: null,
  suspendedBy: null,
});

export const processDiagnostics = (rawDiagnostics) => {
  return rawDiagnostics.map((item) => ({ ...EMPTY_DIAGNOSTICS_ITEM, ...item }));
};

export const reorderAttributesForTable = (columns, items) => {
  return items.map((item) => {
    return columns.reduce((accumulator, column) => {
      accumulator[column.name] = item[column.name];
      return accumulator;
    }, {});
  });
};
